module.exports = __webpack_public_path__ + "static/media/logo.6f460546.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/woodbury/logo.svg
// module id = 163
// module chunks = 0